module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showBblockUi) ? _c('BlockUI', {
    attrs: {
      "message": _vm.msg,
      "url": _vm.uiBlockerImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "donation-area"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.webHeader)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main donation",
    staticStyle: {
      "background-image": "url('static/assets/images/tree-image.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-8"
  }, [_vm._m(6), _vm._v(" "), _c('form', {
    staticClass: "donation-form",
    attrs: {
      "name": "donation-form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.firstName),
      expression: "donerInfo.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "type": "text",
      "id": "fname1",
      "name": "fname1",
      "placeholder": "First Name*",
      "required": ""
    },
    domProps: {
      "value": (_vm.donerInfo.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fname1')),
      expression: "errors.has('fname1')"
    }],
    staticClass: "text-danger"
  }, [_c('small', [_vm._v("First Name should be valid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.lastName),
      expression: "donerInfo.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "type": "text",
      "id": "lname1",
      "name": "lname1",
      "placeholder": "Last Name*",
      "required": ""
    },
    domProps: {
      "value": (_vm.donerInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lname1')),
      expression: "errors.has('lname1')"
    }],
    staticClass: "text-danger"
  }, [_c('small', [_vm._v("Last Name should be valid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("+ 91")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.mobileNo),
      expression: "donerInfo.mobileNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Mobile Number",
      "aria-describedby": "basic-addon1",
      "inputmode": "numeric",
      "oninput": "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');",
      "pattern": "^[6-9]\\d{9}$",
      "minlength": "10",
      "maxlength": "10",
      "name": "mobileNo"
    },
    domProps: {
      "value": (_vm.donerInfo.mobileNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "mobileNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobileNo')),
      expression: "errors.has('mobileNo')"
    }],
    staticClass: "text-danger"
  }, [_c('small', [_vm._v("Mobile Number should be valid")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.emailId),
      expression: "donerInfo.emailId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    attrs: {
      "type": "email",
      "id": "email1",
      "name": "emailId",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.donerInfo.emailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "emailId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.address),
      expression: "donerInfo.address"
    }],
    attrs: {
      "type": "text",
      "id": "address",
      "name": "address",
      "placeholder": "Address*",
      "required": ""
    },
    domProps: {
      "value": (_vm.donerInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "text-danger"
  }, [_c('small', [_vm._v(" Put the valid Address ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.pincode),
      expression: "donerInfo.pincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('digits:6'),
      expression: "'digits:6'"
    }],
    attrs: {
      "type": "text",
      "id": "pincode",
      "name": "pincode",
      "placeholder": "Pincode*",
      "required": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.donerInfo.pincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "pincode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger"
  }, [_c('small', [_vm._v("Please enter valid pincode ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.panNumber),
      expression: "donerInfo.panNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_num'),
      expression: "'alpha_num'"
    }],
    attrs: {
      "type": "text",
      "id": "panNumber",
      "name": "panNumber",
      "placeholder": "PAN Number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.donerInfo.panNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "panNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.comment),
      expression: "donerInfo.comment"
    }],
    attrs: {
      "type": "text",
      "id": "comment1",
      "name": "comment1",
      "placeholder": "Comment"
    },
    domProps: {
      "value": (_vm.donerInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "donation-sub-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row donate-holder"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donerInfo.donationAmount),
      expression: "donerInfo.donationAmount"
    }],
    attrs: {
      "type": "text",
      "id": "donation",
      "name": "donation",
      "placeholder": "Donation Amount (Rs.)"
    },
    domProps: {
      "value": (_vm.donerInfo.donationAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donerInfo, "donationAmount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 block-terms"
  }, [_c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isTnCAccepted),
      expression: "isTnCAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "value": "agree",
      "name": "",
      "id": "agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.isTnCAccepted) ? _vm._i(_vm.isTnCAccepted, "agree") > -1 : (_vm.isTnCAccepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isTnCAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "agree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isTnCAccepted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isTnCAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isTnCAccepted = $$c
        }
      }
    }
  }), _vm._v("\n                        I agree to "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "theme-btn btn-style-two",
    attrs: {
      "type": "button",
      "name": "submit-form",
      "disabled": !_vm.isTnCAccepted
    },
    on: {
      "click": _vm.saveEnquiryDetails
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _vm._m(9)])])])]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.webFooter)
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.url,
      "method": "POST",
      "id": "upsForm",
      "name": "upsForm"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upsString),
      expression: "upsString"
    }],
    attrs: {
      "name": "upsString",
      "type": "hidden",
      "id": "someId"
    },
    domProps: {
      "value": (_vm.upsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upsString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "reqFrom",
      "value": "goLang",
      "type": "hidden"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title",
    staticStyle: {
      "background-image": "url('static/assets/images/how-can-you-contribute.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("HOW CAN YOU CONTRIBUTE?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row sec-padding1"
  }, [_c('div', {
    staticClass: "col-md-12 content-column"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('div', {
    staticClass: "sec-title"
  }, [_c('h2', [_vm._v("How can you contribute?")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row block-donation"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-6 col-sm-12 content-column donation-content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_c('div', {
    staticClass: "sec-heading"
  }, [_c('h2', [_vm._v("We see a world full of"), _c('br'), _vm._v("\n                    Flourishing Youth with"), _c('br'), _vm._v("\n                    a Purposeful Life!\n                  ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-dark"
  }, [_vm._v("We dream to create a vibrant community\n                    of social changemakers spread across India,\n                    bringing positive change in various aspects of society.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "text-dark"
  }, [_vm._v("Donate to NIRMAN and be a part of this glorious vision!")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 donation-image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/donation-img.png",
      "alt": "Donation Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-title-area d-flex align-items-center"
  }, [_c('img', {
    staticClass: "img-leaf",
    attrs: {
      "src": "static/assets/images/petals.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Support the power of the youth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-desc row"
  }, [_c('div', {
    staticClass: "table-donate col-lg-8"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('span', [_vm._v("Rs 5,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost (lodging, boarding, training) of one participant for one NIRMAN Workshop.                    \n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 10,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the travel cost of a resource person for one NIRMAN Workshop.\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 15,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost (lodging, boarding, training) of one participant for the series of 3 NIRMAN Workshops.\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 25,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support a month’s fellowship stipend for a young NIRMAN Fellow working full time for a social cause.\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 50,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost of various thought provoking books to be given as\n                      educative gifts to all the participants from one NIRMAN Batch.\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 75,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost of conducting outreach and selection process for one NIRMAN Batch.\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 1,00,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost of 100 youth volunteers in Krutee NIRMAN action\n                      learning activities across Maharashtra                    \n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Rs 4,00,000")])]), _vm._v(" "), _c('td', [_vm._v("\n                      Support the cost of one NIRMAN Workshop of 8 days for 60 budding social change-makers.\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-donate-qr col-lg-4"
  }, [_c('div', {
    staticClass: "img-holder"
  }, [_c('img', {
    staticClass: "img-qr",
    attrs: {
      "src": "static/assets/images/nirman-qr-code.jpg",
      "alt": "SEARCH NIRMAN QR Code"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-title-area d-flex align-items-center"
  }, [_c('img', {
    staticClass: "img-leaf",
    attrs: {
      "src": "static/assets/images/petals.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Donate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "clas": "donation-title-info"
    }
  }, [_c('div', {
    staticClass: "donation-title-desc"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" You can donate any amount to NIRMAN either from the above menu or any other amount you have in mind. We value each & every contribution. ")]), _vm._v(" "), _c('p', [_vm._v("There are 4 ways you can make the transfer: ")]), _vm._v(" "), _c('ol', {
    staticClass: "donation-desc-list"
  }, [_c('li', [_vm._v("Use the QR code on this page to make the payment.")]), _vm._v(" "), _c('li', [_vm._v("Use the NIRMAN bank account details given besides and make an online transfer there.")]), _vm._v(" "), _c('li', [_vm._v("Draw a cheque with the appropriate bank details and send it to us at NIRMAN, SEARCH, Gadchiroli - 442605, Maharashtra.")]), _vm._v(" "), _c('li', [_vm._v("Use the following utility to fill in your details & click submit to take you to an online payments facility.")])]), _vm._v(" "), _c('p', [_vm._v("Kindly use the method that suits you the best. In order to inform us that you have made the payment and to help us draw the appropriate receipt, we will highly appreciate it if you can send us an email or message at "), _c('a', {
    attrs: {
      "href": "mailto:contact.nirman@gmail.com"
    }
  }, [_vm._v("contact.nirman@gmail.com")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "tel:+918767680508"
    }
  }, [_vm._v("+91-8767680508")]), _vm._v(" with your details. We will send you the receipt within 7 working days. Thanks again!")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fill the following details & hit submit if you wish to use the online payments facility through this page. Else use the QR code or bank account details directly. \n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_c('strong', [_vm._v("Enter Donation Amount")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "tc_space",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Terms and Conditions.\n                          "), _c('div', {
    staticClass: "tc_desc-area"
  }, [_c('span', {
    staticClass: "tc_desc"
  }, [_c('ul', [_c('li', [_vm._v("After successful payment within 15 days we will send you 80G receipt\n                                    of payment on your provided email ID.\n                                  ")]), _vm._v(" "), _c('li', [_vm._v("Payments are processed through Atom technologies ltd, for more\n                                    details visit- "), _c('a', {
    attrs: {
      "href": "https://www.atomtech.in",
      "target": "_blank"
    }
  }, [_vm._v("https://www.atomtech.in")])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Terms of Use are governed by the laws of the Republic of India. In all\n                                    disputes arising out of or relating to the use of this web site or service by\n                                    the user, consent and submission to the exclusive jurisdiction and venue of\n                                    the Courts in Gadchiroli, Maharashtra.\n                                  ")]), _vm._v(" "), _c('li', [_vm._v("NIRMAN reserves the right to modify, amend or amend the amended policy at any time and in\n                                    any manner as it may see fit in this disclaimer. Any changes or modifications will be posted on\n                                    the site.\n                                  ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 block-condition"
  }, [_c('span', [_vm._v("*All Donations are eligible for tax exemption under section 80G of the Income Tax Act")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-4 donation-info"
  }, [_c('h4', {
    staticClass: "donation-title"
  }, [_vm._v("Account Details for Offline Donation")]), _vm._v(" "), _c('p', [_vm._v("  Account title - SEARCH-NIRMAN"), _c('br'), _vm._v("\n                  Bank Name - Bank of Maharashtra "), _c('br'), _vm._v("\n                  Branch - Gadchiroli "), _c('br'), _vm._v("\n                  Account No. - 60011788671  "), _c('br'), _vm._v("\n                  IFS code - MAHB0000940")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de27f65","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactUs/donationData.vue
// module id = 66
// module chunks = 1